import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { login } from "../../actions/authActions";

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { Container, Form, Button, Row, Col, Alert, Spinner } from "react-bootstrap";
import "./login.css";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const signupSuccess = Boolean(location.state?.signupSuccess);

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setApiError("");
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validate = () => {
    const next = { email: "", password: "" };
    if (!email.trim()) next.email = "Email is required.";
    else if (!emailRegex.test(email.trim())) next.email = "Enter a valid email.";
    if (!password.trim()) next.password = "Password is required.";
    setErrors(next);
    return !next.email && !next.password;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (submitting) return;
    setSubmitting(true);
    setApiError("");

    try {
      const result = await dispatch(login(email.trim(), password));
      if (result?.ok) {
        navigate("/", { replace: true });
      } else {
        setApiError(result?.error || "Unable to log in. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />

      <Container className="form-container">
        <Row className="justify-content-md-center">
          <Col xs={11} md={8} className="form-column">

            <h2>Login</h2>

            {signupSuccess && (
              <Alert variant="success" className="mt-2">
                Account created successfully. Please log in.
              </Alert>
            )}

            {apiError && (
              <Alert variant="danger" className="mt-2" role="alert" aria-live="assertive">
                {apiError}
              </Alert>
            )}

            <Form onSubmit={onSubmit} noValidate className="mt-3">
              <Form.Group controlId="formBasicEmail" className="mb-3">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={onChange}
                  autoComplete="email"
                  isInvalid={!!errors.email}
                  disabled={submitting}
                  required
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="formBasicPassword" className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={onChange}
                  autoComplete="current-password"
                  isInvalid={!!errors.password}
                  disabled={submitting}
                  required
                />
                <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
              </Form.Group>

              <div className="d-flex align-items-center gap-2">
                <Button
                  type="submit"
                  className="login-button mt-2"
                  variant="primary"
                  disabled={submitting}
                  aria-busy={submitting}
                >
                  {submitting ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Logging in…
                    </>
                  ) : (
                    "Login"
                  )}
                </Button>
              </div>
            </Form>

            <p className="mt-3">
              Not have account?{" "}
              <Link to={"/signup"}>
                <span>Register here</span>
              </Link>
            </p>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default Login;
